import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sectionFilter',
})
export class SectionFilterPipe implements PipeTransform {
  transform(sections: any[], name: string): any {
    return sections.find(section => section.name === name && section.isAccess);
  }
}
